import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['container', 'source', 'spinner']

  connect() {
    const url = this.data.get('url');
    console.debug('remote content from: ' + url);

    this.loaded = false;
    if (this.data.get('triggerDistanceFromBottom')) {
      document.addEventListener("scroll", this.onScroll.bind(this));
    }
  }

  onScroll() {
    if (this.loaded) {
      return;
    }

    window.requestAnimationFrame(() => {
      const { scrollHeight, scrollTop, clientHeight } = document.documentElement;
      const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

      if (distanceFromBottom < this.data.get('triggerDistanceFromBottom')) {
        this.load();
        this.loaded = true;
      }
    });
  }

  load() {
    let url = this.data.get('url');
    console.debug('load remote content from: ' + url);
    if (this.data.get('param')) {
      url += `?${this.data.get('param')}=${this.sourceTarget.value}`;
    }

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('d-none');
    }

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        if (this.hasSpinnerTarget) {
          this.spinnerTarget.classList.remove('d-none');
        }
        this.containerTarget.innerHTML = html;
        this.loaded = true;
      })
      .catch((err) => console.log(err))
      .finally(() => {
        if (this.hasSpinnerTarget) {
          this.spinnerTarget.classList.add('d-none');
        }
      });
  }
}
